import { render, staticRenderFns } from "./AccountUsersTab.vue?vue&type=template&id=53482021&scoped=true&"
import script from "./AccountUsersTab.vue?vue&type=script&lang=js&"
export * from "./AccountUsersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53482021",
  null
  
)

export default component.exports